import { getReduxStore } from './redux-host.js';
/**
 * @deprecated please use `isModalVisible()`
 */
export function getIsModalVisible(modalId) {
    return ({ modal }) => {
        return modal.visibleModal?.id === modalId;
    };
}
export function isModalVisible(modalId) {
    const { modal } = getReduxStore().getState();
    return modal.visibleModal?.id === modalId;
}
export function getHostInfo() {
    const { host } = getReduxStore().getState();
    if (!Object.keys(host.context).length) {
        throw new Error(`HostInfo is not set. Please set it first using 'setHostInfo()'.`);
    }
    return host;
}
//# sourceMappingURL=getters.js.map